<main>
  <p class="as-font as-font-18 as-font-semibold">{{ data.title }}</p>
  <p class="as-font as-font-16">{{ data.subtitle }}</p>
  <p class="as-font as-font-16">{{ data.opt }}</p>
  <div class="as-buttons">
    @if (data.buttons.help) {
      <button
        (click)="openLiveChatPayment()"
        mat-flat-button
        color="accent"
        class="help"
        >
        {{ data.buttons.help }}
      </button>
    }
    @if (data.buttons.ok) {
      <button
        mat-dialog-close
        mat-flat-button
        color="accent"
        class="ok"
        >
        {{ data.buttons.ok }}
      </button>
    }
  </div>

  @if (data.buttons.both) {
    <div class="as-buttons">
      <button
        (click)="closeModal(false)"
        mat-stroked-button
        color="accent"
        class="cancel"
        >
        Cancelar
      </button>
      <button
        (click)="closeModal(true)"
        mat-flat-button
        color="accent"
        class="ok"
        >
        Confirmar
      </button>
    </div>
  }
</main>
